// extracted by mini-css-extract-plugin
export default {"userManager":"setting_userManager__AWuYz","userManager_left":"setting_userManager_left__0zR3f","userManager_right":"setting_userManager_right__+LaPN"};